import { Tile } from '../../tiles/index.js'
import { fmt, backs } from '../../model/tiles.js'

const HLC = 'var(--color-accent)'

const KICKER = {
  fontFamily: 'var(--font-heading)',
  fontSize: 8.5,
  letterSpacing: 2,
  color: 'var(--color-neutral-500)',
}

function zoneStyle(on, grow) {
  return {
    flex: grow,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    padding: '5px 8px',
    cursor: 'pointer',
    border: '1px dashed ' + (on ? 'var(--color-accent)' : 'var(--color-neutral-300)'),
    background: on ? 'var(--color-accent-100)' : 'transparent',
  }
}

export default function SeatRow({
  seat,
  seatKey,
  isHero,
  view,
  sel,
  onSelectZone,
  onTileClick,
  onCallClick,
  onNewGroup,
}) {
  const hideHand = view === 'focus' && !isHero
  const handSel = sel.seat === seatKey && sel.zone === 'hand'
  const callsSel = sel.seat === seatKey && sel.zone === 'calls'
  const discSel = sel.seat === seatKey && sel.zone === 'discards'

  const handEmpty = (seat.revealed || isHero) && seat.hand.length === 0
  const callsEmpty = !callsSel && (!seat.calls || seat.calls.length === 0)
  const discEmpty = seat.discards.length === 0

  const hw = isHero ? 29 : 22

  const handTiles =
    !seat.revealed && !isHero
      ? backs(13).map((t, idx) => (
          <span
            key={idx}
            onClick={(e) => {
              e.stopPropagation()
              onSelectZone('hand')
            }}
            style={{ cursor: 'pointer' }}
          >
            <Tile tile={t} width={17} highlightColor={HLC} />
          </span>
        ))
      : seat.hand.map((t, idx) => (
          <span
            key={idx}
            onClick={(e) => {
              e.stopPropagation()
              onTileClick('hand', idx)
            }}
            style={{ cursor: 'pointer' }}
          >
            <Tile tile={t} width={hw} highlightColor={HLC} />
          </span>
        ))

  const callGroups = (seat.calls || []).map((g, gi) => (
    <div key={gi} style={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
      {g.map((x, idx) => (
        <span
          key={idx}
          onClick={(e) => {
            e.stopPropagation()
            onCallClick(gi, idx)
          }}
          style={{ cursor: 'pointer' }}
        >
          <Tile tile={idx === 0 ? { ...x, rotated: true } : x} width={20} highlightColor={HLC} />
        </span>
      ))}
    </div>
  ))

  const discTiles = seat.discards.map((t, idx) => (
    <span
      key={idx}
      onClick={(e) => {
        e.stopPropagation()
        onTileClick('discards', idx)
      }}
      style={{ cursor: 'pointer' }}
    >
      <Tile tile={t} width={17} highlightColor={HLC} />
    </span>
  ))

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        padding: '7px 12px',
        border: '1px solid var(--color-neutral-300)',
        background: isHero ? '#fff' : 'transparent',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
        <span style={KICKER}>PLAYER</span>
        <span style={{ fontFamily: 'var(--font-heading)', fontWeight: 600, color: 'var(--color-accent-700)' }}>
          {seat.wind}
        </span>
        <span style={{ fontWeight: 600 }}>{seat.name}</span>
        <span style={{ color: 'var(--color-neutral-600)', fontSize: 11 }}>{fmt(seat.score)}</span>
        {seat.riichi && (
          <span
            style={{
              fontFamily: 'var(--font-heading)',
              fontSize: 9,
              fontWeight: 600,
              letterSpacing: 2,
              color: '#fff',
              background: 'var(--color-accent)',
              padding: '1px 6px',
            }}
          >
            RIICHI
          </span>
        )}
        {!seat.revealed && !isHero && (
          <span style={{ fontSize: 9.5, letterSpacing: 1, color: 'var(--color-neutral-500)' }}>CLOSED</span>
        )}
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'stretch', flexWrap: 'wrap' }}>
        {!hideHand && (
          <div onClick={() => onSelectZone('hand')} style={zoneStyle(handSel, '1.6')}>
            <span style={KICKER}>HAND</span>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-end', minHeight: 32 }}>
              {handTiles}
              {handEmpty && (
                <span style={{ fontSize: 10, color: 'var(--color-neutral-400)', alignSelf: 'center' }}>
                  add from palette / notation
                </span>
              )}
            </div>
          </div>
        )}
        <div onClick={() => onSelectZone('calls')} style={zoneStyle(callsSel, '0.8')}>
          <span style={KICKER}>CALLS</span>
          <div style={{ display: 'flex', gap: 8, minHeight: 32, alignItems: 'center' }}>
            {callGroups}
            {callsSel && (
              <span
                onClick={(e) => {
                  e.stopPropagation()
                  onNewGroup()
                }}
                style={{
                  cursor: 'pointer',
                  fontSize: 9.5,
                  letterSpacing: 1,
                  color: 'var(--color-accent-700)',
                  border: '1px solid var(--color-accent-400)',
                  padding: '3px 7px',
                  background: '#fff',
                }}
              >
                + GROUP
              </span>
            )}
            {callsEmpty && <span style={{ fontSize: 10, color: 'var(--color-neutral-400)' }}>none</span>}
          </div>
        </div>
        <div onClick={() => onSelectZone('discards')} style={zoneStyle(discSel, '1')}>
          <span style={KICKER}>POND</span>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, minHeight: 28, alignItems: 'center' }}>
            {discTiles}
            {discEmpty && <span style={{ fontSize: 10, color: 'var(--color-neutral-400)' }}>empty</span>}
          </div>
        </div>
      </div>
    </div>
  )
}
